export default {
    imageCode: "/gateway/manageBedrock/messagecs/createImageCode", //获取图片验证码
    messageCode: "/gateway/manageBedrock/messagecs/messageCode", //发送短信验证码
    chargeCarrierInviteRegister:
        "/gateway/huilianCharge/chargeCarriercs/chargeCarrierInviteRegister", // 注册
    sendMessageCode: "/gateway/huilianCust/logincs/sendMessageCode"
};



// WEBPACK FOOTER //
// ./src/yysChargingOperator/share/api.js